import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Singleton } from '../../../js/Singleton';
import IntegrationConnectButton from '../Others/IntegrationConnectButton'
import IntegrationConnectWindow from '../Others/IntegrationConnectWindow'
import IntegrationInfoLog from '../Others/IntegrationInfoLog'
import { integrationIcon } from '../../../Images/FooterSVG'
import { STATES_INTEGRATION } from '../../../constants'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import SingletonWebSocket from '../../../js/Singletons/SingletonWebSocket';
import { messageIntegration } from '../../../redux/actions/A_actions_Integration'

class Integration extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
    SingletonWebSocket.SetOnMessage(this);
    this.state = {
      stateConnection: this.sharedData.getIntegrationConnectionStatus(),
      showingLog: false,
      integrationLog: this.sharedData.getIntegrationLog()
    }
    this.stateActions = {
      [STATES_INTEGRATION.connected]: () => this.disconnect(),
      [STATES_INTEGRATION.connecting]: () => this.cancelConnect(),
      [STATES_INTEGRATION.disconnecting]: () => this.connect(),
      [STATES_INTEGRATION.notFound]: () => this.retryConnect(),
    }
    this.isFirstConnect = true;
    this.recconectionTimeout = 4000
    this.reconnectionTriggered = false;
  }
  componentDidMount() {
    if (this.props.integrationAutorun && this.state.stateConnection !== STATES_INTEGRATION.connected && this.isFirstConnect) {
      this.isFirstConnect = false;
      setTimeout(() => { this.connect() }, 2000);
    }
    this.setState({ integrationLog: this.sharedData.getIntegrationLog() });
  }
  componentWillReceiveProps(props) {
    if (props.integrationAutorun && this.state.stateConnection !== STATES_INTEGRATION.connected && this.isFirstConnect) {
      this.isFirstConnect = false;
      setTimeout(() => { this.connect() }, 2000);
    }
  }

  disconnect() {
    SingletonWebSocket.close();
    this.changeState(STATES_INTEGRATION.disconnecting);
  }
  cancelConnect() {
    this.addIntegrationLog("Status " + STATES_INTEGRATION.disconnecting);
    SingletonWebSocket.close();
  }

  onIntegrationMessage(message) {
    this.addIntegrationLog("Message Received", message);
    if (message.action === "firstConnection" && message.client === "integration") {
      let agentData = null;
      if (this.sharedData.getCurrentState() !== 'Logout' && this.sharedData.user) {
        agentData = {
            userName: this.sharedData.user.Login,
            userId: this.sharedData.user.User_id,
            userExt: this.sharedData.parameters.Extension
        };
      }
      const message = { currentState: this.sharedData.getCurrentState(), agentData: agentData }
      let integrationMessage = { client: "galatea", data: message, action: "agentStatusChange" };
      if (message.currentState === "Dialog") {
        let assistedMessage = this.sharedData.getAssistedTransferCurrentState();
        integrationMessage.data.subaction = assistedMessage.subaction;
      }
      SingletonWebSocket.send(integrationMessage);
      this.sharedData.setAssistedTransferCurrentState("");
    }
    else {
      this.props.messageIntegration(message);
    }

  }
  onOpenIntegration() {
    const message = { currentState: this.sharedData.getCurrentState() }
    let integrationMessage = { client: "galatea", data: message, action: "agentStatusChange" };
    SingletonWebSocket.send(integrationMessage);
    this.changeState(STATES_INTEGRATION.connected);
  }
  onCloseIntegration() {
    if (this.state.stateConnection !== STATES_INTEGRATION.notFound) {
      this.changeState(STATES_INTEGRATION.disconnecting);
    }
  }
  onError(err) {
    this.changeState(STATES_INTEGRATION.notFound);
    this.addIntegrationLog("Error " + err);
    if (this.sharedData.isLogged) {
      this.setTimmedReconnection();
    }
  }
  changeState(newState) {
    this.addIntegrationLog("Status " + newState);
    this.setState({ stateConnection: newState });
    if (newState === STATES_INTEGRATION.notFound) {
      this.setTimmedReconnection();
    }
    this.sharedData.setIntegrationConnectionStatus(newState);
  }
  connect() {
    this.changeState(STATES_INTEGRATION.connecting);
    SingletonWebSocket.SetOnMessage(this);
    SingletonWebSocket.setwsServer(this.sharedData.getIntegrationServer());
    SingletonWebSocket.setPort(this.sharedData.getIntegrationPort());
    SingletonWebSocket.connect(this.sharedData.getSecureConnection());
  }
  setTimmedReconnection() {
    if (!this.reconnectionTriggered) {
      this.reconnectionTriggered = true;
      setTimeout(() => {
        this.connect();
        this.reconnectionTriggered = false;
        console.log("[Integration][changeState] Reconnecting");
      }, this.recconectionTimeout);
      console.log("[Integration][onError] Reconection Triggered ", this.recconectionTimeout);
    }
  }
  retryConnect() {
    this.connect();
  }
  connectAction() {
    this.stateActions[this.state.stateConnection]();
  }
  getCurrentTime() {
    var date = new Date();
    var seconds = date.getSeconds();
    var minutes = date.getMinutes();
    var hour = date.getHours();
    return hour + ":" + minutes + ":" + seconds;
  }
  addIntegrationLog(message, json = null) {
    var log = this.sharedData.getIntegrationLog();
    var time = this.getCurrentTime();
    log.push(time + " " + message);
    if (json) {
      log.push("Action: " + json.action);
      var subaction = json.window ? json.window :
        json.subaction ? json.subaction : "";
      log.push("Subaction: " + subaction);
    }
    this.sharedData.setIntegrationLog(log);
    this.setState({ integrationLog: log });
  }
  render() {
    return (
      <div className="integrationContainer">
        <div className="integrationHeader">
          <div className="iconHeaderIntegration">{integrationIcon}</div>
          <p className="titleHeaderIntegration">{this.props.titleIntegration}</p>
          <div className="minimizeIntegration" onClick={() => this.props.closeSocketBoxIntegration()}></div>
        </div>
        {!this.state.showingLog ?
          <div className="integrationBody">
            <IntegrationConnectWindow stateIntegration={this.state.stateConnection} />
            <IntegrationConnectButton
              stateIntegration={this.state.stateConnection}
              connectingAction={() => this.connectAction()}
              sendToLog={() => this.setState({ showingLog: true })}
            />
          </div> :
          <IntegrationInfoLog
            backToIntegration={() => this.setState({ showingLog: false })}
            integrationLog={this.state.integrationLog}
          />
        }
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    messageIntegration: (dataIntegration) => { dispatch(messageIntegration(dataIntegration)); },
  });
}

export default Integration = connect(
  null,
  mapDispatchToProps
)(Integration);


// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/Integration.jsx